import { matchesKeyword, normalizeText, toStringValue } from '@lili/utils/formatting';

export interface MenuItem<T> {
  title: string;
  itemDescription?: string;
  value: T;
}

export const filterItems = <T>(items: MenuItem<T>[], keyword: string) => {
  const normalizedKeyword = normalizeText(keyword);

  return items.filter(
    ({ title, itemDescription, value }) =>
      matchesKeyword(title, normalizedKeyword) ||
      (itemDescription && matchesKeyword(itemDescription, normalizedKeyword)) ||
      matchesKeyword(toStringValue(value), normalizedKeyword)
  );
};
